export default "__VITE_ASSET__Dhho47wp__"